module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10249.6fce0485.jpg";